import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<option selected={{this.isClosest}}>{{@value}}</option>\n",{ moduleName: "garaje/pods/components/dropdown-option/template.hbs" })